import { hydroImages } from "../data/serumsImg/hydroImages";
import { renewalImages } from "../data/serumsImg/renewalImages";
import { antiAgingImages } from "../data/serumsImg/antiAgingImages";
import { selectiveImages } from "../data/serumsImg/selectiveCareImg";
import { boostSetImages } from "../data/serumsImg/boostImages";
import { youthImages } from "../data/serumsImg/youthImages";
import { greenSetImages } from "../data/serumsImg/greenSetImages";
import { ayurvedaSetImages } from "../data/serumsImg/ayurvedaImages";

export const serumsImages = {
  'anti-aging': antiAgingImages,
 'ayurveda': ayurvedaSetImages,
  'boost': boostSetImages,
  'green': greenSetImages,
  'jetCare-hydro': hydroImages,
  'renewal-care': renewalImages,
  'selective-care': selectiveImages,
  'youth': youthImages,
};
